<template>
    <slot name="product-card" v-bind="this"></slot>
</template>

<script>

    export default {
        data() {
            return {
                count: 1,
            };
        },
        props: {
            productId: null,
            productQuantity: null,
            toastMessage: null
        },
        methods: {

            allowOnlyNumbers(e) {
                const regex = /^\d+$/;
                if(!regex.test(e.key)) {
                    e.preventDefault();
                }
            },

            preventEmpty() {
                if (!this.count || Number(this.count) < 1) {
                    this.count = 1;
                }
            },

            showSuccess() {
                this.$swal({
                    toast: true,
                    position: "bottom-left",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: false,
                    text: this.toastMessage,
                    customClass: {
                        popup: 'swal-custom-toast'
                    }
                });
            },



            addToCart( payload ) {
                this.$emit('add-to-cart', payload )
                this.showSuccess()
            },

        }
    }

</script>
